import { Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

const QuestionTitle = ({ label, children, sx = {} }) => {
  return (
    <div className="mb-1 flex w-full items-center justify-between gap-8">
      <Typography
        fontWeight="medium"
        mb={0.5}
        sx={{
          color: HNSColors.neutrals[100],
          fontWeight: "600",
          fontSize: "16px",
          ...sx,
        }}
      >
        {label}
      </Typography>
      {children}
    </div>
  );
};

export default QuestionTitle;
